// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"49cc4738","703":"24a5f44c","787":"c81fdd2f"}[chunkId] + ".chunk.js";
};